import React, {useEffect, useRef, useState} from 'react';
import {
    FlatList,
    TextInput,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';
import TMenuScreen from "../../../screens/public/Menu/Translations/TMenuScreen";
import AppConfig from '../../../AppConfig';
import PublicMenuItem from '../../../components/public/Menu/PublicMenuItem';
import {BorderlessButton} from '../../../custom-packages/react-button-package/ButtonPackage';

import EraserIcon from "../../../assets/custom-icons/EraserIcon";
import {CustomNav} from "../../../components/public/Menu/CustomNav";

import '../../../screens/public/Menu/menu.scss';
import MenuHeaderTabs from "../../../components/public/Menu/MenuHeaderTabs";
import {MenuHeader} from "../../public/Menu/MenuHeader";


const MenuPreview = (props) => {
    const sectionRefs = useRef([]);
    const tabBarRef = useRef(null);

    const [searchText, setSearchText] = useState('');
    const [config, setConfig] = useState(props.config);
    const [currentSection, setCurrentSection] = useState(props.currentSection);
    const [menuSections, setMenuSections] = useState(props.menuSections);
    const [food, setFood] = useState(props.food);

    const registerSectionRef = (sectionId, ref) => {
        sectionRefs.current[sectionId] = ref;
    };

    useEffect(() => {
        setConfig(props.config);
        setCurrentSection(props.currentSection);
        setMenuSections(props.menuSections);
        setFood(props.food);
    }, [props.config, props.currentSection, props.menuSections, props.food]);

    return (
        <View
            style={{
                fontFamily: config.fontFamily,
                backgroundColor: config.backgroundColor,
            }}
            className={'menu-screen'}
        >
            <MenuHeader
                logo={config.logo}
                title={config.name}
                style={{
                    backgroundColor: config.primaryColor,
                    position: 'initial'
                }}
            />
            <View
            >
                <View
                    style={{
                        backgroundColor: config.backgroundColor,
                    }}
                >
                    <MenuHeaderTabs
                        ref={tabBarRef}
                        menuSections={menuSections}
                        config={config}
                        setCurrentSection={setCurrentSection}
                        setMenuSections={setMenuSections}
                        sectionRefs={sectionRefs}
                        setUserScrolled={() => {}}
                        currentSection={currentSection}
                    />
                </View>
            </View>
            <View
                style={{
                    padding: '0 15px'
                }}
            >
                <FlatList
                    keyExtractor={item => {
                        return item.id;
                    }}
                    data={food}
                    renderItem={({item}) => {
                        return <PublicMenuItem
                            item={item}
                            registerSectionRef={registerSectionRef}
                            config={config}
                        />;
                    }}
                    ListHeaderComponent={() => {
                        return null;
                    }}
                    ListFooterComponent={() => {
                        return <View style={{height: 15}}></View>
                    }}
                />
            </View>
        </View>
    );
}

export default MenuPreview;